module.exports = __webpack_public_path__ + "img/people-img-1.e16eedbf.png";